import type { FC } from 'react';
import { useEffect } from 'react';
import { MapPanel } from './components';
import useLoadNetworkData from './hooks/use-load-network-data';
import NetworkMap from './Map';
import { NoDataForNetworkMapModal } from './NoDataForNetworkMapModal';
import SessionsPanel from './SessionsPanel';
import FullscreenLayout from '../../design/layout/FullscreenLayout';
import { roadSectionLineHighlighted } from '../../core/networkMap/state';
import { useAppDispatch } from '../../types';

const MapView: FC = () => {
    const dataLoaded = useLoadNetworkData();
    const dispatch = useAppDispatch();

    useEffect(() => {
        return () => {
            dispatch(roadSectionLineHighlighted(null));
        };
    }, [dispatch]);

    return (
        <FullscreenLayout>
            {!dataLoaded ? null : (
                <>
                    <MapPanel>
                        <NetworkMap />
                    </MapPanel>
                    <SessionsPanel />
                </>
            )}
            <NoDataForNetworkMapModal />
        </FullscreenLayout>
    );
};

export default MapView;
